<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {

  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader,
  },
  data() {
    return {
      title: "Eventos de Rastreio",
      items: [
        {
          text: "Cadastro",
          href: "/"
        },
        {
          text: "Eventos de Rastreio",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      showModalTrackerEvent: false,
      submittedTrackerEvent: false,
      trackerEventData: {},
      errosValid: null,
    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {

    abrirTrackerMsgs(){
      console.log('abrirTrackerMsgs')
      this.$router.push(`/trackermsgss/list`)
    },

    abrirInstanciasWhatsapp(){
      console.log('abrirInstanciasWhatsapp')
      this.$router.push(`/instwhats/list`)
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row)
      this.trackerEventData = row.data
      this.showModalTrackerEvent = true
    },


    novoTrackerEvent(){
      console.log('novoTrackerEvent')
      this.trackerEventData = {}
      this.submittedTrackerEvent = false
      this.showModalTrackerEvent = true
    },


    confTrackerEvent(){
      console.log('confTrackerEvent')
      this.submittedTrackerEvent = true
      if ((this.trackerEventData.tipo && this.trackerEventData.status) &&
          (this.trackerEventData.gatilho !== 'CHV' || (this.trackerEventData.gatilho === 'CHV' && this.trackerEventData.chave1))
      ) {
        this.showModalTrackerEvent = false
        api.post(`${getBaseUrl()}api/trackerevent`, {
          trackerEventData: this.trackerEventData
        }).then((res) => {

          if(res.data[0] === 'erro') {

            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data[1],
              showConfirmButton: false,
              timer: 3500
            })
          } else {
            console.log('res post trackerevent')
            console.log(res)
            this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informação salva com sucesso",
              showConfirmButton: false,
              timer: 1500
            })
          }
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
        })
      }
    },

    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Eventos de Rastreio'
    },

    atualizaDataList(){
      console.log('atualizaDataList_mov')
      console.log(this.exibEmit)
      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/trackerevents`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.status)
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'A':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'I':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {
      if (e.value === "A") {
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    },
  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>
    <div>

      <DxToolbar>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              text="Novo Evento de Rastreio"
              :on-click="novoTrackerEvent"/>
        </DxItem>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="email"
              text="Mensagens de Rastreio"
              :on-click="abrirTrackerMsgs"/>
        </DxItem>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="mention"
              text="Instâncias WhatsApp"
              :on-click="abrirInstanciasWhatsapp"/>
        </DxItem>
      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!updating">
      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />

        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />

        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strTrackerEventsList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            data-field="id"
            sort-order="desc"
            caption="ID"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tipo"
            caption="Tipo"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="transpcnpj"
            caption="CNPJ Transportadora"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="destcnpj"
            caption="CNPJ Destinatário"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="chave"
            caption="Chaves"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="gatilho"
            caption="Gatilho"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="status"
            caption="Status"
            alignment="left"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="created_at"
            caption="Criado"
            alignment="right"
            data-type="datetime"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>
    </div>


    <b-modal size="xl"
             :title="trackerEventData.id > 0 ? `Editar Evento de Rastreio (${ trackerEventData.id })` : 'Criando novo Evento de Rastreio'"
             v-model="showModalTrackerEvent" centered hide-footer>
      <div>
        <div class="card-body">

          <div class="row mb-2">

            <div class="col-md-4">
              <div class="mb-2">
                <label for="tipo">Tipo</label>
                <select
                    id="tipo"
                    v-model="trackerEventData.tipo"
                    class="form-control"
                    :class="{'is-invalid': submittedTrackerEvent && !trackerEventData.tipo}">
                  <option value="WZAP">Whatsapp</option>
                  <option value="EMAIL">E-mail</option>
                </select>
                <div v-if="submittedTrackerEvent && !trackerEventData.tipo" class="invalid-feedback">
                  <span>Campo Tipo obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-2">
                <label for="statuscont">Status</label>
                <select id="statuscont"
                        v-model="trackerEventData.status"
                        :class="{'is-invalid': submittedTrackerEvent && !trackerEventData.status}"
                        class="form-control">
                  <option value="A">Ativo</option>
                  <option value="I">Inativo</option>
                </select>
                <div v-if="submittedTrackerEvent && !trackerEventData.status" class="invalid-feedback">
                  <span>Campo Status obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-2">
                <label for="gatilho">Gatilho</label>
                <select id="gatilho"
                        v-model="trackerEventData.gatilho"
                        :class="{'is-invalid': submittedTrackerEvent && !trackerEventData.gatilho}"
                        class="form-control">
                  <option value="ENF">Entrada Nota Fiscal</option>
                  <option value="ECT">Entrada Conhecimento de Transporte</option>
                  <option value="CHV">Contém chave</option>
                </select>
                <div v-if="submittedTrackerEvent && !trackerEventData.gatilho" class="invalid-feedback">
                  <span>Campo Gatilho obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>

          <div class="row mb-2">
            <div class="col-md-6">
              <label for="transpcnpj">CNPJ Transportadora</label>
              <div class="position-relative">
                <input
                    id="transpcnpj"
                    type="text"
                    v-model="trackerEventData.transpcnpj"
                    class="form-control"
                    :disabled="true"
                    placeholder="CNPJ Transportadora"/>
              </div>
            </div>
            <div class="col-md-6">
              <label for="destcnpj">CNPJ Destinatário</label>
              <div class="position-relative">
                <input
                    id="destcnpj"
                    type="text"
                    v-model="trackerEventData.destcnpj"
                    class="form-control"
                    :disabled="true"
                    placeholder="CNPJ Destinatário"/>
              </div>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-sm-12">
              <div class="mb-3">
                <label for="mensagem">Mensagem</label>
                <br>
                <label for="mensagem">Variáveis</label>
                <span class="badge rounded-pill bg-primary ms-2">[nome_empresa]</span>
                <span class="badge rounded-pill bg-secondary ms-2">[nome_cliente]</span>
                <span class="badge rounded-pill bg-primary ms-2">[numero_nf]</span>
                <span class="badge rounded-pill bg-primary ms-2">[emissao_nf]</span>
                <span class="badge rounded-pill bg-secondary ms-2">[serie_nf]</span>
                <span class="badge rounded-pill bg-primary ms-2">[chave_nf]</span>
                <br>
                <textarea id="mensagem"
                          v-model="trackerEventData.mensagem"
                          type="text" rows="10"
                          class="form-control"
                          placeholder="Mensagem" />
              </div>
            </div>
          </div>


          <div class="row mb-2" v-if="trackerEventData.gatilho === 'CHV'">

            <div class="col-md-3">
              <label for="chave1">Chave 1</label>
              <div class="position-relative">
                <input
                    id="chave1"
                    type="text"
                    v-model="trackerEventData.chave1"
                    class="form-control"
                    :class="{'is-invalid': submittedTrackerEvent && !trackerEventData.chave1}"
                    placeholder="Chave 1"/>
                <div v-if="submittedTrackerEvent && !trackerEventData.chave1" class="invalid-feedback">
                  <span>Campo Chave1 obrigatório para gatilho CHV, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="chave2">Chave 2</label>
              <div class="position-relative">
                <input
                    id="chave2"
                    type="text"
                    v-model="trackerEventData.chave2"
                    class="form-control"
                    placeholder="Chave 2"/>
              </div>
            </div>

            <div class="col-md-2">
              <label for="chave3">Chave 3</label>
              <div class="position-relative">
                <input
                    id="chave3"
                    type="text"
                    v-model="trackerEventData.chave3"
                    class="form-control"
                    placeholder="Chave 3"/>
              </div>
            </div>

            <div class="col-md-2">
              <label for="chave4">Chave 4</label>
              <div class="position-relative">
                <input
                    id="chave4"
                    type="text"
                    v-model="trackerEventData.chave4"
                    class="form-control"
                    placeholder="Chave 4"/>
              </div>
            </div>

            <div class="col-md-2">
              <label for="chave5">Chave 5</label>
              <div class="position-relative">
                <input
                    id="chave5"
                    type="text"
                    v-model="trackerEventData.chave5"
                    class="form-control"
                    placeholder="Chave 5"/>
              </div>
            </div>

          </div>

        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalTrackerEvent = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confTrackerEvent">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>



  </Layout>
</template>
